import React, { Component, createRef, useState, useEffect } from "react";
import { Row, Col, Card, Button, Space, Typography, Table, Input, Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faSearch } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";

const NEW_CLIENT_CATEGORY_BASE_STATE = { name: "" };

function ClientCategories(props) {
  const [clientCategories, setClientCategories] = useState([]);
  const [filteredClientCategories, setFilteredClientCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);

  const [selectedClientCategory, setSelectedClientCategory] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [newClientCategory, setNewClientCategory] = useState(NEW_CLIENT_CATEGORY_BASE_STATE);

  const table_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Typography.Title level={5}>{text}</Typography.Title>,
      sorter: (a, b) => (a.name > b.name ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "# of Clients Using this Category",
      dataIndex: "used_by_count",
      key: "used_by_count",
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (text, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              setEditModalOpen(true);
              setSelectedClientCategory(clientCategories.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>
          <Button
            size="small"
            danger
            onClick={() => {
              setDeleteModalOpen(true);
              setSelectedClientCategory(clientCategories.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-1" />
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const GetClientCategories = async () => {
    let response = await props.AxiosRequest("/api/client-categories/get");
    setClientCategories(response.data.client_categories);
    setFilteredClientCategories(response.data.client_categories);
  };
  const UpdateClientCategory = async () => {
    if (selectedClientCategory.name.length === 0) return props.MakeNotification("warning", "Please enter a name for the client category.");
    await props.AxiosRequest("/api/client-categories/update", { id: selectedClientCategory.id, name: selectedClientCategory.name });
    GetClientCategories();
    setEditModalOpen(false);
    setSelectedClientCategory(null);
  };
  const DeleteClientCategory = async () => {
    await props.AxiosRequest("/api/client-categories/delete", { id: selectedClientCategory.id });
    GetClientCategories();
    setDeleteModalOpen(false);
    setSelectedClientCategory(null);
  };
  const AddClientCategory = async () => {
    if (newClientCategory.name.length === 0) return props.MakeNotification("info", "Please Enter All Required Fields.");
    await props.AxiosRequest("/api/client-categories/insert", { name: newClientCategory.name });
    GetClientCategories();
    setAddModalOpen(false);
    setNewClientCategory(NEW_CLIENT_CATEGORY_BASE_STATE);
  };

  useEffect(() => {
    GetClientCategories();
  }, []);

  useEffect(() => {
    if (searchTerm?.length === 0) return setFilteredClientCategories(clientCategories);
    let filtered_list = clientCategories.filter((f) => (_.toLower(f.name).indexOf(_.toLower(searchTerm)) > -1 ? true : false));
    setFilteredClientCategories(filtered_list);
  }, [searchTerm]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Client Categories</h1>
        </div>
        <Row>
          <Card
            title={<>Client Categories</>}
            style={{
              width: "100%",
            }}
            extra={
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setNewClientCategory(NEW_CLIENT_CATEGORY_BASE_STATE);
                    setAddModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon="plus" className="me-2" />
                  Add A New Client Category
                </Button>
              </>
            }
          >
            <Row>
              <Col span={18}></Col>
              <Col span={6}>
                <Input
                  className="mb-2"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  placeholder="Search..."
                  allowClear
                />
              </Col>
            </Row>
            <Table className="table table-striped hover" columns={table_columns} dataSource={filteredClientCategories} />
          </Card>
        </Row>
        <Modal
          title={"Edit Client Category"}
          centered
          open={editModalOpen}
          onCancel={() => {
            setEditModalOpen(false);
            setSelectedClientCategory(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedClientCategory(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  UpdateClientCategory();
                }}
              >
                Save Changes
              </Button>
            </>
          }
        >
          {selectedClientCategory ? (
            <>
              <label className="col-form-label-sm">Client Category Name *</label>
              <Input
                value={selectedClientCategory.name}
                onChange={(e) => {
                  setSelectedClientCategory({ ...selectedClientCategory, name: e.target.value });
                }}
              />
            </>
          ) : null}
        </Modal>

        <Modal
          title={"Are you sure?"}
          centered
          open={deleteModalOpen}
          onCancel={() => {
            setDeleteModalOpen(false);
            setSelectedClientCategory(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedClientCategory(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => {
                  DeleteClientCategory();
                }}
              >
                Delete
              </Button>
            </>
          }
        >
          {selectedClientCategory ? <>Are you sure you want to delete the client category {selectedClientCategory?.name}?</> : null}
        </Modal>

        <Modal
          title={"Add A New Client Category"}
          centered
          open={addModalOpen}
          onCancel={() => {
            setAddModalOpen(false);
            setSelectedClientCategory(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setAddModalOpen(false);
                  setSelectedClientCategory(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  AddClientCategory();
                }}
              >
                Add
              </Button>
            </>
          }
        >
          {newClientCategory ? (
            <>
              <label className="col-form-label-sm">Client Category Name *</label>
              <Input
                value={newClientCategory.name}
                onChange={(e) => {
                  setNewClientCategory({ ...newClientCategory, name: e.target.value });
                }}
              />
            </>
          ) : null}
        </Modal>
      </div>
    </main>
  );
}

export default ClientCategories;
